import {DashboardType} from "../../../model/dashboard/types";
import {projectProgressConfig} from "./project-progress";
import {projectAgileConfig} from "./project-agile";
import {projectSummaryConfig} from "./summary";
import {DashboardTemplateConfig} from "../../templates-custom";


const emptyConfig = () => {}

export const emptyProjectDashboardTemplate : DashboardTemplateConfig = {
    templateId      : 'project-empty',
    name            : 'Empty',
    dashboardTitle  : 'Dashboard',
    description     : 'Create a project dashboard from scratch.',
    preview         : 'add-custom-dashboard-v2.svg',
    dashboardType   : DashboardType.PROJECT,
    configFunction  : emptyConfig
}

export const dashboardTemplatesProject : DashboardTemplateConfig[] = [

    {
        templateId  : 'project-agile',
        name        : 'Sprint/Agile Dashboard',
        description : 'Real-time visibility into your sprint\'s progress and team performance.',
        preview     : 'agile-preview.svg',
        dashboardType   : DashboardType.PROJECT,
        configFunction  : projectAgileConfig
    },

    {
        templateId  : 'project-summary',
        name        : 'Project Summary',
        description : "Track project progress, milestones, performance and other key metrics.",
        preview     : 'project-summary-preview.svg',
        dashboardType   : DashboardType.PROJECT,
        configFunction  : projectSummaryConfig
    },
    {
        templateId  : 'project-progress',
        name        : 'Project Progress',
        description : 'Track and monitor project progress in real-time with actionable insights.',
        preview     : 'project-progress-preview.svg',
        dashboardType   : DashboardType.PROJECT,
        configFunction  : projectProgressConfig
    },

    emptyProjectDashboardTemplate
]

